import { render, staticRenderFns } from "./TheTabArancel.vue?vue&type=template&id=625b1f29&"
import script from "./TheTabArancel.vue?vue&type=script&lang=js&"
export * from "./TheTabArancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports